import _ from 'lodash';
import { getValidEncodes } from './platforms';
import { store } from '../../../store.js';
import { GetRegion } from 'constants.js';
import Utils from 'utils/Utils';
import { getEncodesByKey } from 'utils/getEncodesByKey';

const getEncode = (content, language, isLive) => {
  const defaultLanguageselected = sessionStorage.getItem(
    'default_audio_option_selected',
  );

  const validEncodes = getEncodesByKey(isLive) || getValidEncodes(isLive);
  const languages = _.get(
    content.group,
    'common.extendedcommon.media.language.options.option',
    [],
  );
  const defaultLanguage = languages[0];
  const encode = validEncodes.filter(value =>
    defaultLanguage.encodes.includes(value),
  );
  if (languages.length === 0) {
    console.log('Error, no hay encodes disponibles');
    return null;
  }
  if (language) {
    const optionIndex = languages.findIndex(l => l.option_id === language);
    if (optionIndex < 0)
      return { language: defaultLanguage, encode: encode[0] };
    const e = validEncodes.filter(value =>
      languages[optionIndex].encodes.includes(value),
    );
    return { language: languages[optionIndex], encode: e[0] };
  } else if (!language && !defaultLanguageselected) {
    return { language: defaultLanguage, encode: encode[0] };
  } else if (!language && defaultLanguageselected) {
    const optionIndex = languages.findIndex(
      l => l.option_id === defaultLanguageselected,
    );
    if (optionIndex < 0)
      return { language: defaultLanguage, encode: encode[0] };
    const e = validEncodes.filter(value =>
      languages[optionIndex].encodes.includes(value),
    );
    return { language: languages[optionIndex], encode: e[0] };
  } else {
    return { language: defaultLanguage, encode: encode[0] };
  }
};

export default getEncode;
